import {createStyles} from "@mantine/core";

export default createStyles((theme) => ({
    item_wrap: {
        width: '33.33%',
        padding: '0 12px'
    },
    card: {
        position: 'relative',
        zIndex: 1,
        // borderRadius: '20px',
        overflow: "hidden",

        '&:hover': {
            img: {
                transform: 'scale(1.1)'
            }
        }
    },
    card_img_block: {
        position: "relative",
        margin: '0 0 6px',
        borderRadius: '20px',
        overflow: 'hidden'
    },
    card_img_block_inner: {
        position: "relative",
        borderRadius: '20px',
        overflow: 'hidden',
        zIndex: 1,
        paddingTop: '56%',
        height: 0,

        img: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: '50% 50%',
            zIndex: 1,
            transition: '0.3s transform !important',
        }
    },
    meta: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: "wrap",
        rowGap: '8px',
        marginBottom: '8px',

    },
    meta_date: {
        fontSize: '13px',
        lineHeight: '1.4',
        margin: '0 0 0',
        color: '#94959B',

    },
    meta_type: {
        background: '#F0F0F4',
        borderRadius: '10px',
        padding: '4px 8px 4px 6px',
        marginRight: '10px',
        alignItems: 'center',
        display: 'flex',

        div: {
            lineHeight: '1.4',
            fontSize: '13px',
            color: '#212328'
        }
    },
    title: {
        overflow: 'hidden',
        wordBreak: 'break-word',

        div: {
            fontSize: '24px',
            marginTop: 0,
            lineHeight: '1.2',
            fontWeight: 500,
            fontFamily: "'Euclid',Helvetica,Arial,sans-serif",
        }
    },
    link: {
        color: '#212328',
        fontWeight: 500,
        lineHeight: 1.2,
        '&:hover': {
            textDecoration: "none"
        }
    }
}));